module.exports = __webpack_public_path__ + "img/pills-avatar.27ed4693.jpeg";